module.exports = ".form-control.ui-switch {\n    background-color: #FFFFFF;\n    border: none;\n    border-radius: 4px;\n    color: #565656;\n    padding: 0px 0px;\n    height: 40px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.disabled {\n\tpointer-events: none;\n\tcursor: not-allowed;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/update-company/update-company.component.css
// module id = ./src/app/components/update-company/update-company.component.css
// module chunks = main